import FormData from "../models/FormData";
import service from "./service";
import Urls from "./Urls";
import ValueLabel from "../models/valueLabel";
import {AxiosResponse} from "axios";
import LocalStorage from "../tools/LocalStorage";


function serviceFormData(callback = (formData: FormData, data: any) => {
}) {
    let formData = new FormData()
    const Token=LocalStorage.getToken();
    if(!Token){
        callback(formData,null);
        return;
    }
    if (formData.legal_facilities_request_type.length === 0) {
        if (navigator.onLine) {

            const thisJsonBody = {"Cellphone": null};
            service.post(Urls.getSelectsData, thisJsonBody,{
                headers: {
                    "Authorization": Token.token_type + " " + Token.access_token
                }
            }).then((response: AxiosResponse) => {

                const {data} = response;
                const {Status, Data} = data;
                if (Status === 0) {

                    for (const singleItem of Data["account_types"]) {
                        const styledItem = new ValueLabel();
                        styledItem.label = singleItem["name"];
                        styledItem.value = singleItem["id"];
                        formData.account_types.push(styledItem);
                    }

                    for (const singleItem of Data["billing_review_types"]) {
                        const styledItem = new ValueLabel();
                        styledItem.label = singleItem["name"];
                        styledItem.value = singleItem["id"];
                        formData.billing_review_types.push(styledItem);
                    }

                    for (const singleItem of Data["cities"]) {
                        const styledItem = new ValueLabel();
                        styledItem.label = singleItem["name"];
                        styledItem.value = singleItem["id"];
                        formData.cities.push(styledItem);
                    }
                    for (const singleItem of Data["village_cities"]) {
                        const styledItem = new ValueLabel();
                        styledItem.label = singleItem["name"];
                        styledItem.value = singleItem["id"];
                        formData.village_cities.push(styledItem);
                    }

                    for (const singleItem of Data["construction_document_type"]) {
                        const styledItem = new ValueLabel();
                        styledItem.label = singleItem["name"];
                        styledItem.value = singleItem["id"];
                        formData.construction_document_type.push(styledItem);
                    }

                    for (const singleItem of Data["legal_facilities_request_type"]) {
                        const styledItem = new ValueLabel();
                        styledItem.label = singleItem["name"];
                        styledItem.value = singleItem["id"];
                        formData.legal_facilities_request_type.push(styledItem);

                    }
                    callback(formData, Data)


                }

            }).catch((error => {

            })).finally(() => {
                callback(formData, null)
            })

        }


    }

}

export {serviceFormData}